import React from 'react';
import { TextField, InputAdornment } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { isReverse } from 'helpers/intl';

export interface InputProps {
  name: string;
  label?: string;
  placeholder?: string;
  value: string;
  [key: string]: any;
}

const InputField = (props: InputProps) => {
  const {
    handleChange,
    handleBlur,
    startAdornment,
    endAdornment,
    placeholder,
    name,
    value,
    error,
    helperText,
    type,
    label,
    InputLabelProps,
    InputProps,
    multiline,
    rows,
  } = props;

  const lang = useSelector(getLocaleSelector);
  const reverse = isReverse(lang);

  return (
    <TextField
      label={label}
      variant="outlined"
      onChange={handleChange}
      onBlur={handleBlur}
      type={type}
      InputLabelProps={InputLabelProps}
      InputProps={{
        startAdornment: !!startAdornment && (
          <InputAdornment
            style={{
              marginLeft: `${reverse ? '8px' : '0px'}`,
              marginRight: `${reverse ? '0px' : '8px'}`,
            }}
            position="start"
          >
            {startAdornment}
          </InputAdornment>
        ),
        endAdornment: !!endAdornment && (
          <InputAdornment position="end">{endAdornment}</InputAdornment>
        ),
        ...InputProps,
      }}
      placeholder={placeholder}
      name={name}
      value={value}
      error={error}
      helperText={helperText}
      fullWidth
      multiline={multiline}
      rows={rows}
    />
  );
};

export default InputField;
